import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Popover, Button } from 'antd';
import { SwatchesPicker  } from 'react-color';

class ColorPicker extends Component {
	constructor() {
		super(...arguments);
		this.handlers = {
			onChange: color => {
				const { onChange, valueType } = this.props;
				let newColor;
				if (valueType === 'string') {
					newColor = `rgba(${color.rgb.r},${color.rgb.g},${color.rgb.b},${color.rgb.a})`;
				}
				else if (valueType === 'hex') {
					newColor = this.rgbToHex(color.rgb.r, color.rgb.g, color.rgb.b);
				}
				else {
					newColor = color.rgb;
				}
				this.setState({
					color: newColor,
				}, () => {
					onChange(newColor);
				});
			},
		};
		this.state = {
			color: this.props.value || 'rgba(255, 255, 255, 1)',
		};
		this.getBackgroundColor = color => {
			if (typeof color === 'string') {
				return color;
			}
			return `rgba(${color.r},${color.g},${color.b},${color.a})`;
		};
	}

	rgbToHex = (r, g, b) => {
		const toHex = (component) => {
		  const hex = component.toString(16);
		  return hex.length === 1 ? '0' + hex : hex;
		};
		return `#${toHex(r)}${toHex(g)}${toHex(b)}`;
	  };

	UNSAFE_componentWillReceiveProps(nextProps) {
		this.setState({
			color: nextProps.value || this.state.color,
		});
	}
	render() {
		const { color } = this.state;
		const { onChange } = this.handlers;
		return (<Popover trigger="click" placement="bottom" content={<SwatchesPicker color={color} onChange={onChange}/>}>
			<Button style={{ background: this.getBackgroundColor(color) }} shape="circle"/>
		</Popover>);
	}
}
ColorPicker.propTypes = {
	valueType: PropTypes.oneOf(['string', 'object', 'hex']),
};
ColorPicker.defaultProps = {
	valueType: 'string',
};
export default ColorPicker;
